import { BaseService } from '../../infra/base.service'
import type { ScheduleBlockRulesRepository } from './schedule-block-rules.repository'
import type { ScheduleBlockRuleEntity } from './schedule-block-rule.entity'

export class ScheduleBlockRulesService extends BaseService<ScheduleBlockRuleEntity> {
    constructor(private rep: ScheduleBlockRulesRepository) {
        super(rep)
    }
}
